export default __webpack_public_path__ + "static/media/e581ed3d68e275f8a8cad7ebd3269a34.svg";